import React from 'react';
import { StyledCheckboxGroup } from './CheckboxOptionGroup.styles';

const CheckboxOptionGroup: React.FC<{
    'aria-label': string;
    'data-testid'?: string;
    children: React.ReactNode;
}> = ({ children, ...props }) => (
    <StyledCheckboxGroup role="group" className="checkbox-option-group" {...props}>
        {children}
    </StyledCheckboxGroup>
);

export default CheckboxOptionGroup;
